import React from 'react';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import clicksound from '../components/music/click.mp3';

const ButtonBack = ({ setModalExit, player1Score, player2Score }) => {
    const navigate = useNavigate();
  const handleBackClick = () => {
    const audio = new Audio(clicksound);
    audio.play();
      if (player1Score === 0 || player2Score === 0) {
        navigate("/");
      } else {
        setModalExit(true);
      }
  };

  return (
    <button
      className="back-button lg:w-14 lg:h-14 sm:w-10 sm:h-10"
      onClick={handleBackClick}
    >
      <FontAwesomeIcon icon={faArrowLeft} className="lg:text-2xl sm:text-xl" />
    </button>
  );
};

export default ButtonBack;
